import { stats } from "@/mocks/blackMaterial";

const toneText: Record<string, string> = {
  primary: "text-primary-300",
  accent: "text-accent-300",
  secondary: "text-foreground-100",
};

export function StatBar() {
  return (
    <div className="border-b border-background-200 bg-background-50">
      <div className="mx-auto grid max-w-[1200px] grid-cols-2 gap-x-6 gap-y-8 px-4 py-10 md:px-6 lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="flex flex-col gap-1.5">
            <div className="flex items-baseline gap-1">
              <span className="font-[number] text-4xl leading-none text-foreground-950">{s.num}</span>
              <span className={`font-[number] text-sm ${toneText[s.tone]}`}>{s.unit}</span>
            </div>
            <div className="text-sm font-semibold text-foreground-800">{s.label}</div>
            <div className="text-xs text-foreground-500">{s.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=cinematic%20dark%20studio%20moody%20lighting%20deep%20crimson%20and%20charcoal%20tones%20with%20soft%20smoke%20and%20abstract%20flame%20shapes%20radiating%20from%20center%2C%20dramatic%20contrast%2C%20editorial%20reportage%20atmosphere%2C%20dark%20backdrop%20for%20text%20overlay%2C%20high%20detail&width=1800&height=1000&seq=blm-hero&orientation=landscape')",
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/45 to-black/75" />
      </div>

      <div className="relative mx-auto flex min-h-[620px] w-full max-w-[1200px] flex-col items-center justify-center px-4 pb-20 pt-32 text-center md:min-h-[680px] md:px-6">
        <div className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-black/25 px-4 py-1.5 backdrop-blur">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary-400" />
          <span className="text-xs tracking-[0.14em] text-background-50/90">谁正在风口浪尖 · 持续复核更新</span>
        </div>

        <h1 className="mt-8 max-w-4xl text-[26px] font-bold leading-snug text-background-50 md:text-5xl md:leading-[1.2]">
          谁在风口浪尖，
          <br className="hidden md:block" />
          谁又被扒到底裤不剩。
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-7 text-background-50/75 md:text-base md:leading-8">
          69黑料把各路争议主角、翻车人物与塌房名单逐条盘点进档。
          谁立了又倒、谁越描越黑，人物全景一屏看尽。
        </p>

        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#ranking"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto cursor-pointer"
          >
            <i className="ri-fire-line text-lg" />
            查看本周翻车榜单
          </a>
          <a
            href="#topics"
            className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto cursor-pointer"
          >
            <i className="ri-article-line text-lg" />
            逛逛人物话题墙
          </a>
        </div>

        <div className="mt-12 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-[11px] text-background-50/55">
          <span>更新至</span>
          <span className="font-semibold text-background-50/85">2026-09-06</span>
          <span className="mx-1 h-1 w-1 rounded-full bg-background-50/30" />
          <span>286 份人物档案已归档</span>
          <span className="mx-1 h-1 w-1 rounded-full bg-background-50/30" />
          <span>人工双信源复核</span>
        </div>
      </div>
    </section>
  );
}